
import Vue from "vue";
import VueRouter from "vue-router";
import Products from "@/views/membership/Products";
import Supplier from "@/views/membership/Supplier";
import Managementdef from "@/views/membership/Managementdef";
import Shippermanagement from "@/views/membership/Shippermanagement";
import Account from "@/views/membership/Account";
import Message from "@/views/membership/Message";
import Changepass from "@/views/membership/Changepass";

Vue.use(VueRouter);

export default [
  {
    meta: {
      title: "产品管理"
    },
    path: "products",//产品管理
    name: "Products",
    component: Products
  },
  {
    meta: {
      title: "供应商管理"
    },
    path: "supplier",//供应商管理
    name: "Supplier",
    component: Supplier
  },
  {
    meta: {
      title: "进口商管理"
    },
    path: "managementdef",//进口商管理
    name: "Managementdef",
    component: Managementdef
  },
  {
    meta: {
      title: "发货人管理"
    },
    path: "shippermanagement",//发货人管理
    name: "Shippermanagement",
    component: Shippermanagement
  }, {
    meta: {
      title: "账号管理"
    },
    path: "account",//账号管理
    name: "Account",
    component: Account
  }, {
    meta: {
      title: "修改密码"
    },
    path: "changepass",//修改密码
    name: "Changepass",
    component: Changepass
  },
  {
    meta: {
      title: "消息中心"
    },
    path: "message",//消息中心
    name: "Message",
    component: Message
  }]